<template>
    <div>
        <select-dropdown
            v-model="filterFields.responsibleUserIds"
            reference="id"
            label="name"
            :auto-translate="false"
            :multiple="true"
            :searchable="true"
            :loading="!companyUsers"
            :options="companyUsers"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
        />
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import User from "../../models/User";

export default {
    name: 'FilterJobResponsibleUser',
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        companyUsers() {
            return useRepo(User).orderBy('name').get();
        },
    },
}
</script>
